export default __webpack_public_path__ + "static/media/image0.1c4e7db6.jpeg";